import { NavbarCtas } from './navbar-ctas';
import type { NavbarMobileBottomProps } from './type';

export function NavbarMobileBottom({
  bottom,
  ctaHref,
  onClickCta,
  phone,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
}: NavbarMobileBottomProps) {
  if (!showFreeCaseReviewButton && !showTalkToSpecialistButton) {
    return null;
  }

  const gridCols =
    showFreeCaseReviewButton && showTalkToSpecialistButton ? 'grid-cols-2' : 'grid-cols-1';

  return (
    <div
      className={`rounded-t-2xl bg-white/50 backdrop-blur-[6.5px] fixed bottom-0 left-0 right-0 z-100 grid ${gridCols} gap-2 py-4 px-2`}
      style={{ bottom, transition: 'bottom 0.3s ease-out' }}
    >
      <NavbarCtas
        onClickCta={onClickCta}
        ctaHref={ctaHref}
        initialState={false}
        phone={phone}
        showFreeCaseReviewButton={showFreeCaseReviewButton}
        showTalkToSpecialistButton={showTalkToSpecialistButton}
      />
    </div>
  );
}
